import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ: React.FC = () => {
	const faqs = [
		{
			id: "q1",
			question: "プログラミング初心者でも参加できますか？",
			answer:
				"はい、参加可能です。チーム内でプログラミング経験者とペアを組んでいただきます。また、メンターによるサポートも充実していますので、ご安心ください。",
		},
		{
			id: "q2",
			question: "個人での参加は可能ですか？",
			answer:
				"はい、個人での参加も歓迎です。開始時にチーム編成の時間を設けており、他の参加者とチームを組んでいただけます。スキルバランスを考慮してチーム編成をサポートします。",
		},
		{
			id: "q3",
			question: "オンラインでの参加は可能ですか？",
			answer:
				"今回のハッカソンは対面形式での開催を予定しています。チーム開発やネットワーキングの効果を最大限に高めるため、可能な限り会場での参加をお願いしています。",
		},
		{
			id: "q4",
			question: "必要な持ち物は何ですか？",
			answer:
				"ノートパソコンをご持参ください。開発に必要なソフトウェアは事前にインストールをお願いします。詳細は参加者向けガイドラインでご案内します。その他、必要に応じてメモ帳等をお持ちください。",
		},
		{
			id: "q5",
			question: "成果物の権利はどうなりますか？",
			answer:
				"開発された成果物の権利は、原則として開発チームに帰属します。ただし、企業賞へのエントリーなど、特別な条件がある場合は別途ご案内いたします。",
		},
	];

	return (
		<section className="py-16">
			<div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-4 text-center">よくある質問</h2>
				<p className="text-gray-600 text-center mb-12">
					ハッカソン参加に関する疑問にお答えします
				</p>
				<Accordion type="single" collapsible className="space-y-4">
					{faqs.map((faq) => (
						<AccordionItem key={faq.id} value={faq.id}>
							<AccordionTrigger className="text-left">
								{faq.question}
							</AccordionTrigger>
							<AccordionContent>{faq.answer}</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</div>
		</section>
	);
};

export default FAQ;
